/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useGridApiRef, GridActionsCellItem } from '@mui/x-data-grid-pro';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import AskDialog from '../../../components/common/dialog/AskDialog';
import { Link, Box, Avatar, Typography } from '@mui/material';
import _ from 'lodash';

import * as employeeApi from '../../../lib/api/employee';
import ApprovalLineList from '../../../components/profilemng/approval/ApprovalLineList';
import {
  listApprovalLine,
  unloadApprovalLine,
} from '../../../modules/empModule/empApproval';
import UsrSelectbox from '../../../components/common/datagrid/UsrSelectbox';

const ApprovalListContainer = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [origialRow, setOrigialRow] = useState(null);

  const { user, approvalLines, error, loading } = useSelector(
    ({ auth, empModule, loading }) => ({
      user: auth.user, //user정보
      approvalLines: empModule.employeeApproval.approvalLines,
      error: empModule.employeeApproval.error,
      loading: loading['employee/LIST_APPROVAL_LINE'],
    }),
  );

  useEffect(() => {
    dispatch(listApprovalLine());

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadApprovalLine());
    };
  }, []);

  const apiRef = useGridApiRef();

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleCellFocusOut = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleEditClick = (id) => (event) => {
    event.stopPropagation();
    apiRef.current.setRowMode(id, 'edit');
  };

  const handleSaveClick = (id) => (event) => {
    event.stopPropagation();
    apiRef.current.commitRowChange(id);
    apiRef.current.setRowMode(id, 'view');

    const row = apiRef.current.getRow(id);

    //edit api call
    setOrigialRow(_.cloneDeep(row)); //error발생시 복구를 위해
    //save
    onSave(row);
  };

  const onSave = async (row) => {
    const copiedRow = _.cloneDeep(row);
    copiedRow.useYn = copiedRow.useYn === true ? 'Y' : 'N';

    try {
      const response = await employeeApi.editApprovalLine(copiedRow);

      if (response.data) {
        //apiRef.current.updateRows([{ ...row, isNew: false }]);
        dispatch(listApprovalLine());
        enqueueSnackbar('수정 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      apiRef.current.updateRows([{ ...row, isNew: false }]);
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const handleCancelClick = (id) => (event) => {
    event.stopPropagation();
    apiRef.current.setRowMode(id, 'view');

    const row = apiRef.current.getRow(id);
    if (row.isNew) {
      apiRef.current.updateRows([{ id, _action: 'delete' }]);
    }
  };

  const [removeId, setRemoveId] = useState(null);
  const handleDeleteClick = (id) => (event) => {
    event.stopPropagation();

    //remove 작업
    setVisible(true);
    setRemoveId(id);
  };

  const onRemove = async () => {
    try {
      const res = await employeeApi.removeApprovalLine(removeId);
      if (res) {
        apiRef.current.updateRows([{ id: removeId, _action: 'delete' }]);
        enqueueSnackbar('삭제 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setRemoveId(null);
  };

  const renderEditUsr1 = (params) => {
    params.name = 'usrUuid1';
    return <UsrSelectbox {...params} />;
  };

  const renderEditUsr2 = (params) => {
    params.name = 'usrUuid2';
    return <UsrSelectbox {...params} />;
  };

  const renderEditUsr3 = (params) => {
    params.name = 'usrUuid3';
    return <UsrSelectbox {...params} />;
  };

  const renderEditUsr4 = (params) => {
    params.name = 'usrUuid4';
    return <UsrSelectbox {...params} />;
  };

  const renderEditUsr5 = (params) => {
    params.name = 'usrUuid5';
    return <UsrSelectbox {...params} />;
  };

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'apprUuid',
        hide: true,
        type: 'string',
        editable: false,
      },

      {
        field: 'apprNm',
        headerName: '결재선명',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: true,
      },

      {
        field: 'usrUuid1',
        headerName: '결재자1',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: true,
        renderEditCell: renderEditUsr1,
        renderCell: (params) => {
          return (
            <>
            {params.row.usrUuid1 ? (
              <>
                <Box sx={{ flexShrink: 0 }}>
                  {params.row?.usrUuid1Profile !== null &&
                  params.row?.usrUuid1Profile !== '' ? (
                    <Avatar
                      alt={params.row?.usrUuid1Nm}
                      src={params.row?.usrUuid1Profile}
                    />
                  ) : (
                    <Avatar>
                      {params.row.usrUuid1Nm
                        ? params.row?.usrUuid1Nm.substring(0, 1)
                        : ''}
                    </Avatar>
                  )}
                </Box>
                <Box sx={{ flexGrow: 1, ml: 1 }}>
                  <Typography variant="subtitle1">
                    {params.row?.usrUuid1Nm} {params.row?.gradeNm1}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    {params.row?.dptNm1}
                  </Typography>
                </Box>
              </>
            ) : (
              ''
            )}
          </>
          );
        },
      },
      {
        field: 'usrUuid2',
        headerName: '결재자2',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: true,
        renderEditCell: renderEditUsr2,
        renderCell: (params) => {
          return (
            <>
            {params.row.usrUuid2 ? (
              <>
                <Box sx={{ flexShrink: 0 }}>
                  {params.row?.usrUuid2Profile !== null &&
                  params.row?.usrUuid2Profile !== '' ? (
                    <Avatar
                      alt={params.row?.usrUuid2Nm}
                      src={params.row?.usrUuid2Profile}
                    />
                  ) : (
                    <Avatar>
                      {params.row.usrUuid2Nm
                        ? params.row?.usrUuid2Nm.substring(0, 1)
                        : ''}
                    </Avatar>
                  )}
                </Box>
                <Box sx={{ flexGrow: 1, ml: 1 }}>
                  <Typography variant="subtitle1">
                    {params.row?.usrUuid2Nm} {params.row?.gradeNm2}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    {params.row?.dptNm2}
                  </Typography>
                </Box>
              </>
            ) : (
              ''
            )}
          </>
          );
        },
      },
      {
        field: 'usrUuid3',
        headerName: '결재자3',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: true,
        renderEditCell: renderEditUsr3,
        renderCell: (params) => {
          return (
            <>
            {params.row.usrUuid3 ? (
              <>
                <Box sx={{ flexShrink: 0 }}>
                  {params.row?.usrUuid3Profile !== null &&
                  params.row?.usrUuid3Profile !== '' ? (
                    <Avatar
                      alt={params.row?.usrUuid3Nm}
                      src={params.row?.usrUuid3Profile}
                    />
                  ) : (
                    <Avatar>
                      {params.row.usrUuid3Nm
                        ? params.row?.usrUuid3Nm.substring(0, 1)
                        : ''}
                    </Avatar>
                  )}
                </Box>
                <Box sx={{ flexGrow: 1, ml: 1 }}>
                  <Typography variant="subtitle1">
                    {params.row?.usrUuid3Nm} {params.row?.gradeNm3}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    {params.row?.dptNm3}
                  </Typography>
                </Box>
              </>
            ) : (
              ''
            )}
          </>
          );
        },
      },
      {
        field: 'usrUuid4',
        headerName: '결재자4',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: true,
        renderEditCell: renderEditUsr4,
        renderCell: (params) => {
          return (
            <>
            {params.row.usrUuid4 ? (
              <>
                <Box sx={{ flexShrink: 0 }}>
                  {params.row?.usrUuid4Profile !== null &&
                  params.row?.usrUuid4Profile !== '' ? (
                    <Avatar
                      alt={params.row?.usrUuid4Nm}
                      src={params.row?.usrUuid4Profile}
                    />
                  ) : (
                    <Avatar>
                      {params.row.usrUuid4Nm
                        ? params.row?.usrUuid4Nm.substring(0, 1)
                        : ''}
                    </Avatar>
                  )}
                </Box>
                <Box sx={{ flexGrow: 1, ml: 1 }}>
                  <Typography variant="subtitle1">
                    {params.row?.usrUuid4Nm} {params.row?.gradeNm4}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    {params.row?.dptNm4}
                  </Typography>
                </Box>
              </>
            ) : (
              ''
            )}
          </>
          );
        },
      },
      {
        field: 'usrUuid5',
        headerName: '결재자5',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: true,
        renderEditCell: renderEditUsr5,
        renderCell: (params) => {
          return (
            <>
              {params.row.usrUuid5 ? (
                <>
                  <Box sx={{ flexShrink: 0 }}>
                    {params.row?.usrUuid5Profile !== null &&
                    params.row?.usrUuid5Profile !== '' ? (
                      <Avatar
                        alt={params.row?.usrUuid5Nm}
                        src={params.row?.usrUuid5Profile}
                      />
                    ) : (
                      <Avatar>
                        {params.row.usrUuid5Nm
                          ? params.row?.usrUuid5Nm.substring(0, 1)
                          : ''}
                      </Avatar>
                    )}
                  </Box>
                  <Box sx={{ flexGrow: 1, ml: 1 }}>
                    <Typography variant="subtitle1">
                      {params.row?.usrUuid5Nm} {params.row?.gradeNm5}
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      {params.row?.dptNm5}
                    </Typography>
                  </Box>
                </>
              ) : (
                ''
              )}
            </>
          );
        },
      },

      // {
      //   field: 'crtUsr',
      //   headerName: '생성자',
      //   minWidth: 80,
      //   flex: 0.3,
      //   type: 'string',
      //   editable: false,
      // },
      {
        field: 'crtDt',
        headerName: '생성일',
        minWidth: 100,
        flex: 0.5,
        type: 'dateTime',
        editable: false,
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Actions',
        width: 100,
        cellClassName: 'actions',
        getActions: ({ id }) => {
          const isInEditMode = apiRef.current.getRowMode(id) === 'edit';

          if (isInEditMode) {
            return [
              <GridActionsCellItem
                icon={<SaveIcon />}
                label="Save"
                onClick={handleSaveClick(id)}
                color="primary"
              />,
              <GridActionsCellItem
                icon={<CancelIcon />}
                label="Cancel"
                className="textPrimary"
                onClick={handleCancelClick(id)}
                color="inherit"
              />,
            ];
          }

          return [
            <GridActionsCellItem
              icon={<EditIcon />}
              label="Edit"
              className="textPrimary"
              onClick={handleEditClick(id)}
              color="inherit"
            />,
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={handleDeleteClick(id)}
              color="inherit"
            />,
          ];
        },
      },
    ],
    [apiRef, handleEditClick, handleSaveClick, handleCancelClick],
  );

  const [visible, setVisible] = useState(false);

  const onCancle = () => {
    setVisible(false);
    setRemoveId(null);
  };

  const onConfirm = () => {
    setVisible(false);
    onRemove();
  };

  return (
    <>
      <ApprovalLineList
        apiRef={apiRef}
        columns={columns}
        rows={approvalLines}
        error={error}
        loading={loading}
        handleRowEditStart={handleRowEditStart}
        handleRowEditStop={handleRowEditStop}
        handleCellFocusOut={handleCellFocusOut}
      />
      <AskDialog
        visible={visible}
        title="결재선 삭제"
        description="선택한 결재선을 삭제하시겠습니까?"
        confirmText="삭제"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </>
  );
};

export default ApprovalListContainer;
